module.exports = __webpack_public_path__ + "static/media/onion-layers.93409a8b.svg";